<mat-card class="dialog-card oyan-ui-ward-form-dialog" data-cy="oyan-ui-ward-form-dialog">
  <mat-card-title class="dialog-card-header">
    <mat-toolbar class="dialog-toolbar flex flex-row items-center justify-between" color="accent">
      <h1 class="dialog-card-title">{{ 'SITES.WARDS.FORM.TITLE' | translate }}</h1>
      <button (click)="close()" class="regular-round-button" data-cy="oyan-ui-ward-form-dialog-close-icon" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
  </mat-card-title>

  <mat-card-content class="dialog-card-content p-4">
    <iot-platform-ui-form-group [fields]="fields()" [group]="form" />
  </mat-card-content>

  <mat-card-actions class="dialog-card-actions flex flex-row items-center justify-end">
    <button (click)="close()" class="button-regular" data-cy="oyan-ui-ward-form-dialog-cancel-button" mat-button>
      {{ 'IOT_DICTIONARY.CANCEL' | translate | uppercase }}
    </button>
    <button (click)="save()" [disabled]="!canSubmit()" class="button-regular" color="accent" data-cy="oyan-ui-ward-form-dialog-save-button" mat-raised-button>
      {{ 'IOT_DICTIONARY.SAVE' | translate | uppercase }}
    </button>
  </mat-card-actions>
</mat-card>
